import React from 'react'
import { Tabs } from 'antd';
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

const Demo = () => (
  <div  className="center" style={{textAlign: "center"}}>
    <h2>Zero Effect Conservational</h2>
    <Tabs defaultActiveKey="1" onChange={callback} style={{margin: '0 auto', width: 500}} centered>
      <TabPane tab="Login" key="1">
        <LoginForm />
      </TabPane>
      <TabPane tab="Register" key="2">
        <RegisterForm />
      </TabPane>
    </Tabs>
  </div>
);

export default Demo